<template>
    <div class="home">
        <menuBox :step="2"></menuBox>
        <div class="depan-box">
            <div class="title-box">
                <div>Lấy đổi mới làm động lực để dẫn dắt sự phát triển trong tương lai</div>
                <p>Công ty có kế hoạch đóng góp tích cực vào sự phát triển kinh tế bền vững bằng cách lấy đổi mới công nghệ và mở rộng dịch vụ làm động lực. Chiến lược toàn diện này được kỳ vọng sẽ tạo ra nhiều giá trị xã hội hơn.</p>
            </div>
        </div>

        <div class="business-box">
            <div class="title">mong đợi của chúng tôi</div>
            <div class="onlist"></div>
            <div class="sbtitle">Hợp tác xã Tiết kiệm và Cho vay VayNow được thiết kế để hỗ trợ sự tăng trưởng và phát triển của các cá nhân và doanh nghiệp. Dù là khoản vay kinh doanh hay tín dụng cá nhân, chúng tôi cam kết cung cấp các giải pháp tài chính linh hoạt và minh bạch để giúp khách hàng vượt qua các rào cản tài chính và đạt được ước mơ, mục tiêu của mình. </div>
            <div class="item-box">
                <div class="item">
                    <img src="../assets/icon-1.png" alt="">
                    <div class="text">1. Đổi mới tài chính</div>
                    <div class="online"></div>
                    <div class="text-2">Sử dụng công nghệ tiên tiến để cung cấp các hoạt động tài chính toàn diện.</div>
                    <div class="btn-t">TÌM HIỂU THÊM</div>
                </div>

                <div class="item">
                    <img src="../assets/icon-2.png" alt="">
                    <div class="text">2. Trách nhiệm xã hội</div>
                    <div class="online"></div>
                    <div class="text-2">Hỗ trợ sự phát triển kinh tế của các cá nhân và doanh nghiệp.</div>
                    <div class="btn-t">TÌM HIỂU THÊM</div>
                </div>

                <div class="item">
                    <img src="../assets/icon-3.png" alt="">
                    <div class="text">3.Mở rộng dịch vụ</div>
                    <div class="online"></div>
                    <div class="text-2">Bảo vệ an ninh tài chính và hạnh phúc của họ.</div>
                    <div class="btn-t">TÌM HIỂU THÊM</div>
                </div>
            </div>
        </div>

        <div class="del-data-box">
            <div class="tel-box" v-if="steps == 1">
                <div class="tip">Sử dụng chức năng xóa dữ liệu, để bảo mật dữ liệu, bạn cần xác minh danh tính của mình</div>
                <div class="title">Vui lòng nhập số điện thoại di động của bạn</div>
                <input v-model="mobile" type="text" class="tel-in" placeholder="Vui lòng nhập số điện thoại">
                <input v-model="password" type="password" class="tel-pa" placeholder="Vui lòng nhập mật khẩu APP">
                <div class="btn" @click="delSearch">Bước tiếp theo</div>
            </div>

            <div class="tel-box" v-else-if="steps == 2">
                <div class="text-box">
                    Kính gửi người dùng
                    <br> Xin chào! Cảm ơn bạn rất nhiều vì đã lựa chọn sử dụng VayNow APP.
                    <br> Trước khi yêu cầu xóa tài khoản, vui lòng đảm bảo rằng tất cả đơn đặt hàng của bạn đã được hoàn thành và hiện không có đơn đặt hàng nào đang được xem xét. Xin lưu ý rằng khi tài khoản bị xóa, dữ liệu sẽ không thể phục hồi được. Vui lòng xác nhận cẩn thận trước khi vận hành. APP này không chịu trách nhiệm cho bất kỳ thiệt hại nào gây ra cho tài sản cá nhân.
                    <br> Nếu bạn đã xác nhận rằng bạn muốn xóa dữ liệu của mình, vui lòng nhấp vào nút bên dưới.
                </div>
                <div class="btn" @click="candelete">xác nhận xóa</div>
            </div>
            <div class="tel-box" v-else-if="steps == 3">
                <div class="title">Vui lòng nhập mã xác minh để xác minh danh tính của bạn</div>
                <div class="iump-box">
                    <input v-model="code" type="text" class="car-in tel-in" placeholder="Vui lòng nhập mã xác minh gồm 4 chữ số">
                    <div class="count-btn" @click="Reenviar"> {{ Time > 0 ? Time : 'lấy mã xác minh' }} </div>
                </div>
                <div class="btn" @click="doDelete">Quá nhiều</div>
            </div>
            <div class="tel-box del-box" v-else-if="steps == 4">
                <img src="../assets/del.png" alt="">
                <p>Dữ liệu của bạn đã bị xóa!</p>
            </div>
            <div class="tel-box" v-else-if="steps == 5">
                <div class="title">Xác minh chứng minh thư</div>
                <input v-model="idcard" type="text" class="tel-in" placeholder="Vui lòng nhập số CMND của bạn">
                <div class="btn" @click="verifyIdCard">Quan sát</div>
            </div>

        </div>

        <div class="sukses-box">
            <img src="../assets/img-8.png" alt="">
            <div class="sukses-text">
                <div class="success">trường hợp thành công</div>
                <p>Hợp tác xã Tiết kiệm và Cho vay VayNow cam kết hỗ trợ vay vốn cho các doanh nghiệp nhỏ và siêu nhỏ. Sau đây là một câu chuyện thành công tương tự: một công ty công nghệ đổi mới muốn mở rộng quy mô sản xuất nhưng không thể mua thiết bị mới và tuyển thêm nhân viên do không đủ năng lực. quỹ. Sau khi tư vấn và đánh giá chi tiết khoản vay, công ty đã đăng ký vay từ VayNow. Với khoản vay này, công ty đã mua thành công thiết bị sản xuất tiên tiến và thuê thêm nhân viên. Lượng đơn đặt hàng của công ty tăng lên đáng kể nhờ hiệu quả sản xuất được cải thiện và chất lượng sản phẩm được cải thiện. Bằng việc mở rộng quy mô sản xuất, công ty đã đạt được mục tiêu tăng gấp đôi doanh số và nhờ đó đạt được lợi nhuận ổn định.</p>
                <div class="sukses-btn">TÌM HIỂU THÊM</div>
            </div>
        </div>



        <div class="pattom"></div>
        <footerBox></footerBox>

        <div class="flex-box" v-if="msgDlg">
            <div class="msg-box">
                <div class="msg">
                    <img src="../assets/title-err.png" class="err-img">
                    {{ msg }}
                </div>
                <img src="../assets/close.png" class="close" @click="msgDlg = false">
            </div>
        </div>
    </div>
</template>
  
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
import * as api from "@/api/api";

export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
            mobile: '',
            password: '',
            code: '',
            msgDlg: false,
            msg: '',
            steps: 1,
            infoData: {},
            Time: 0,
            idcard: '',
            verifyIDCard: '',
        }
    },
    mounted() {

    },
    methods: {
        delSearch() {
            let data = {
                mobile: this.mobile,
                password: this.password
            }
            console.log(this.$loading);
            let loding = this.$loading.show({})
            api.delInfoSearch(data).then(res => {
                loding.hide()
                this.infoData = res.data
                this.steps = 2
            }).catch(e => {
                loding.hide()
                this.msgDlg = true
                this.msg = e.message
            })
        },
        candelete() {
            let data = {
                user_id: this.infoData.user_id
            }
            let loding = this.$loading.show({})
            api.delInfoCanDelete(data).then(res => {
                loding.hide()
                if (res.data.idcard) {
                    this.verifyIDCard = res.data.idcard
                    this.steps = 5
                } else {
                    this.steps = 3
                    this.Reenviar()
                }
            }).catch(e => {
                loding.hide()
                this.msgDlg = true
                this.msg = e.message
            })
        },
        verifyIdCard() {
            console.log(this.verifyIDCard);
            if (this.verifyIDCard == this.idcard) {
                this.steps = 3
                this.Reenviar()
            } else {
                this.msgDlg = true
                this.msg = 'Thẻ ID đã được nhập không chính xác và xác minh không thành công.'
            }
        },
        Reenviar() {
            if (this.Time > 0) {
                return
            }
            this.Countdown(60)
            let data = {
                mobile: this.mobile
            }
            let loding = this.$loading.show({})
            api.delInfoSms(data).then(res => {
                loding.hide()
            }).catch(e => {
                loding.hide()
                this.msgDlg = true
                this.msg = e.message
            })
        },
        doDelete() {
            if (!this.code) {
                this.msgDlg = true
                this.msg = 'Mã xác minh phải được điền'
                return
            }
            let loding = this.$loading.show({})
            let data = {
                mobile: this.mobile,
                code: this.code,
                user_id: this.infoData.user_id
            }
            api.delInfoDoDelete(data).then(res => {
                loding.hide()
                this.steps = 4
            }).catch(e => {
                loding.hide()
                this.msgDlg = true
                this.msg = e.message
            })
        },
        Countdown(time) {
            this.Time = time
            if (time <= 0) {
                return
            }

            setTimeout(() => {
                this.Countdown(time - 1)
            }, 1000);
        }
    }
}
</script>
  
  
<style lang="less" scoped>
.depan-box {
    width: 100%;
    height: 800px;
    background-image: url(../assets/bg-1.png);
    background-size: 100% 100%;
    margin-top: -1px;
    display: flex;
    flex-direction: column;
    // align-items: center;
    justify-content: center;

    color: #FFFFFF;

    .title-box {
        margin-left: 256px;
        width: 662px;

        div {
            font-size: 50px;
            font-weight: bold;
        }

        p {
            margin-top: 43px;
            font-size: 16px;
        }
    }
}

.business-box {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 129px;

    .title {
        font-size: 50px;
        font-weight: bold;
        color: #333333;
    }

    .onlist {
        width: 150px;
        height: 3px;
        background: #0050FF;
        margin-top: 24px;
    }

    .sbtitle {
        width: 472px;
        font-size: 14px;
        color: #737373;
        margin-top: 16px;
    }

    .item-box {
        width: 1203px;
        padding: 84px 0px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .item {
            width: 270px;
            min-height: 355px;
            background: #FFFFFF;
            box-shadow: 0px 5px 32px 0px rgba(93, 112, 223, 0.1);
            border-radius: 10px;
            padding: 40px 60px;
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;

            img {
                width: 49px;
            }

            .text {
                font-size: 22px;
                color: #243668;
                margin-top: 28px;
            }

            .online {
                width: 100px;
                height: 4px;
                background: #1F65FF;
                border-radius: 100px;
                margin-top: 18px;
            }

            .text-2 {
                font-size: 16px;
                color: #838FAE;
                margin-top: 32px;
                text-align: center;
            }

            .btn-t {
                width: 200px;
                height: 50px;
                background: #1F65FF;
                box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.08);
                font-size: 15px;
                color: #FFFFFF;
                margin-top: 10px;
                line-height: 50px;
                text-align: center;
                border-radius: 25px;
            }
        }
    }
}

.sukses-box {
    padding: 80px 390px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    img {
        width: 500px;
    }

    .sukses-text {
        width: 600px;

        .success {
            font-size: 50px;
            font-weight: bold;
            color: #021744;
        }

        p {
            font-size: 16px;
            color: #838FAE;
            margin-top: 32px;
        }

        .sukses-btn {
            width: 200px;
            height: 50px;
            background: #1f65ff;
            border-radius: 32px;
            font-size: 15px;
            color: #FFFFFF;
            margin-top: 50px;
            line-height: 50px;
            text-align: center;
            border-radius: 25px;
        }
    }
}

.del-data-box {
    background: #F5F5F5;
    padding: 100px 560px;

    .tel-box {
        min-height: 155px;
        background: #FFFFFF;
        padding: 40px 150px;
        display: flex;
        flex-direction: column;
        align-items: self-start;

        .tip {
            font-size: 16px;
            font-weight: 400;
            color: #333333;
        }

        .title {
            font-size: 24px;
            font-weight: 400;
            color: #333333;
            margin-top: 24px;
        }

        .tel-in,
        .tel-pa {
            width: 452px;
            height: 60px;
            border-radius: 5px;
            border: 1px solid #EFEFEF;
            margin-top: 14px;
            padding: 0px 24px;
            font-size: 16px;
            font-weight: 400;
            color: #333333;
            line-height: 60px;
        }

        .iump-box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 24px;
            width: 500px;
        }

        .car-in {
            width: 302px;
            margin: 0;
        }

        .btn {
            width: 452px;
            height: 60px;
            padding: 0px 24px;
            background: #1F65FF;
            border-radius: 5px;
            font-size: 16px;
            font-weight: 400;
            color: #FFFFFF;
            text-align: center;
            line-height: 60px;
            margin-top: 24px;
            cursor: pointer;
        }

        .count-btn {
            width: 120px;
            height: 60px;
            border-radius: 8px;
            border: 1px solid #EFEFEF;
            line-height: 60px;
            font-size: 16px;
            font-weight: 400;
            color: #1F65FF;
            text-align: center;
            cursor: pointer;
        }

        .text-box {
            font-size: 16px;
            font-weight: 400;
            color: #333333;
        }
    }

    .del-box {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;

        img {
            width: 97px;
        }

        p {
            font-size: 16px;
            font-weight: 400;
            margin-top: 24px;
        }
    }
}

.flex-box {
    position: fixed;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    background: fade(#000, 90%);
    display: flex;
    align-items: center;
    justify-content: center;

    .msg-box {
        position: relative;

        .err-img {
            width: 100px;
            margin-top: -100px;
        }

        .msg {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            background: #fff;
            text-align: center;
            color: #999;
            font-size: 26px;
            padding: 50px;
            width: 380px;
            border-radius: 17px;

        }

        .close {
            position: absolute;
            right: 10px;
            top: 10px;
            width: 30px;
        }
    }
}
</style>
  